// Pre-baked prompts users can fire with one click. Each fills the input field
// (so the user can edit before sending) rather than auto-sending — safer with
// write-actions in the loop.

const ACTIONS: { label: string; prompt: string; requiresSelection?: boolean }[] = [
  { label: "Vat samen", prompt: "Vat deze presentatie samen in 3 bullets." },
  { label: "Titeldia", prompt: "Maak een titeldia met een passende titel en subtitel op basis van de inhoud." },
  { label: "Verbeter tekst", prompt: "Herschrijf de tekst op de geselecteerde dia: bondiger, professioneler, geen jargon.", requiresSelection: true },
  { label: "Outline", prompt: "Maak een outline van 5 dia's over: " },
  { label: "Consistentie", prompt: "Scan de presentatie op inconsistente lettertypes en -groottes en maak de opmaak consistent." },
];

export function QuickActions({
  onPick,
  hasSelection,
}: {
  onPick: (prompt: string) => void;
  hasSelection: boolean;
}) {
  return (
    <div className="flex flex-wrap gap-1">
      {ACTIONS.map((a) => {
        const disabled = a.requiresSelection && !hasSelection;
        return (
          <button
            key={a.label}
            type="button"
            disabled={disabled}
            onClick={() => onPick(a.prompt)}
            title={disabled ? "Selecteer eerst een dia" : a.prompt}
            className="rounded-full border border-border bg-bg px-2 py-0.5 text-xs text-fg hover:border-secondary disabled:opacity-40 disabled:hover:border-border"
          >
            {a.label}
          </button>
        );
      })}
    </div>
  );
}
